import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { propertiesActionTypes } from '~client/constants/actionTypes';

export const defaultState = Immutable.fromJS({
  list: {
    communication: defaultCommunicationObject,
    totalCount: 0,
    payload: [],
  },
  listings: {
    property: {},
    payload: [],
    communication: defaultCommunicationObject,
  },
  updateListing: defaultCommunicationObject,
});

const getPropertiesList = list =>
  list.map(item => ({
    id: item.node.slug,
    name: item.node.name,
  }));

const propertiesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case propertiesActionTypes.SET_PROPERTIES: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: getPropertiesList(action.payload.viewer.company.properties.edges),
          totalCount: action.payload.viewer.company.properties.totalCount,
        },
      });
    }

    case propertiesActionTypes.GET_PROPERTIES_CS:
      return state.mergeDeep({
        list: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case propertiesActionTypes.SET_LISTINGS: {
      const nextState = state.deleteIn(['listings', 'payload']).deleteIn(['listings', 'property']);
      return nextState.mergeDeep({
        listings: {
          property: action.payload.viewer.company.properties.edges[0].node,
          payload: action.payload.viewer.company.properties.edges[0].node.listings.edges,
        },
      });
    }

    case propertiesActionTypes.GET_LISTINGS_CS:
      return state.mergeDeep({
        listings: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case propertiesActionTypes.UPDATE_LISTING_CS:
      return state.mergeDeep({
        updateListing: updateCommunicationObject(action.status, action.error),
      });

    default:
      return state;
  }
};

export default propertiesReducer;
